// extracted by mini-css-extract-plugin
export default {"accordionContainer":"SectionAccordion_accordionContainer__-jhv4","accordionHeader":"SectionAccordion_accordionHeader__zZqce","accordionBody":"SectionAccordion_accordionBody__Ipob7"};